// AnnouncerContext.tsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import { VisuallyHidden } from '@chakra-ui/react';

const AnnouncerContext = createContext<{ announce: (msg: string) => void } | null>(null);

export function AnnouncerProvider({ children }: { children: React.ReactNode }) {
  const [message, setMessage] = useState('');

  const announce = useCallback((msg: string) => {
    // Reset first to force re-announcement even if same string
    setMessage('');
    setTimeout(() => setMessage(msg), 1000);
  }, []);

  return (
    <AnnouncerContext.Provider value={{ announce }}>
      {children}
      <VisuallyHidden tabIndex={0} role="alert" aria-live="polite">
        {message}
      </VisuallyHidden>
    </AnnouncerContext.Provider>
  );
}

export function useAnnouncer() {
  const ctx = useContext(AnnouncerContext);
  if (!ctx) throw new Error('useAnnouncer must be used inside AnnouncerProvider');
  return ctx;
}
